document.addEventListener('DOMContentLoaded', () => {
  const manufacturerSelect = document.getElementById('manufacturer');
  const modelSelect = document.getElementById('model');
  const yearSelect = document.getElementById('year');
  const searchButton = document.getElementById('searchButton');

  let carData = [];

  const clean = str => str.trim().toLowerCase();
  const isValidYear = val => {
    const num = Number(val);
    const thisYear = new Date().getFullYear();
    return num >= 1980 && num <= thisYear + 1;
  };

  async function loadManufacturerData(manufacturer) {
    carData = await getModelsByManufacturer(manufacturer);
    const uniqueModels = Array.from(new Set(
      carData.map(item => item.model.trim())
    ));
    uniqueModels.sort((a, b) => a.localeCompare(b));

    modelSelect.innerHTML = '<option value="">בחר דגם</option>';
    yearSelect.innerHTML = '<option value="">בחר שנה</option>';
    modelSelect.disabled = false;
    yearSelect.disabled = true;
    searchButton.disabled = true;

    uniqueModels.forEach(model => {
      const option = document.createElement('option');
      option.value = model;
      option.textContent = model;
      modelSelect.appendChild(option);
    });
  }

  manufacturerSelect.addEventListener('change', async () => {
    const manufacturer = manufacturerSelect.value;
    if (!manufacturer) return;

    modelSelect.disabled = true;
    yearSelect.disabled = true;
    searchButton.disabled = true;
    modelSelect.innerHTML = '<option value="">טוען דגמים...</option>';

    await loadManufacturerData(manufacturer);
  });

  modelSelect.addEventListener('change', () => {
    const selectedModel = modelSelect.value;

    yearSelect.innerHTML = '<option value="">בחר שנה</option>';
    yearSelect.disabled = true;
    searchButton.disabled = true;

    if (!selectedModel) return;

    const years = carData
      .filter(item => item.model === selectedModel)
      .map(item => item.year)
      .filter(isValidYear);

    const uniqueYears = Array.from(new Set(years));
    uniqueYears.sort((a, b) => Number(a) - Number(b));

    uniqueYears.forEach(year => {
      const option = document.createElement('option');
      option.value = year;
      option.textContent = year;
      yearSelect.appendChild(option);
    });

    if (uniqueYears.length > 0) {
      yearSelect.disabled = false;
    }
  });

  yearSelect.addEventListener('change', () => {
    if (manufacturerSelect.value && modelSelect.value && yearSelect.value) {
      searchButton.disabled = false;
    } else {
      searchButton.disabled = true;
    }
  });

  searchButton.addEventListener('click', () => {
    const manufacturer = manufacturerSelect.value;
    const model = modelSelect.value;
    const year = yearSelect.value;

    if (manufacturer && model && year) {
      const query = encodeURIComponent(`${manufacturer} ${model} ${year}`);
      window.location.href = `/search?type=product&q=${query}`;
    }
  });

  // טיפול בחזרה אחורה מהיסטוריה
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      location.reload();
    }
  });
});
